import { render } from "./EmailTemplatesManager.vue?vue&type=template&id=7d5455b6"
import script from "./EmailTemplatesManager.vue?vue&type=script&lang=js"
export * from "./EmailTemplatesManager.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__